/**
 * Which sound the operator hears while the number they dialled is ringing.
 *
 * The mirror of `incoming/ringSource.ts` with ONE DIFFERENCE, and it is the
 * whole reason this file is not that one: there is no default of ours. Nothing
 * is shipped for the outgoing ring, so an installation that has uploaded
 * nothing keeps the Voice SDK's own sound, exactly as every call did before
 * this setting existed. That is why the fallback below is empty and why every
 * caller has to ask `hasCustomRingback()` first - "no address" here means
 * "leave Twilio alone", not "play the built-in one".
 */
import { createOwnSound } from "../ownSound";

const sound = createOwnSound("");

/** Records the operator's own outgoing ring, or clears it. */
export function setRingbackSource(url: string | null | undefined): void {
  sound.set(url);
}

/** The address to ring with, or "" when there is none. Check `hasCustomRingback` first. */
export function ringbackSource(): string {
  return sound.url();
}

/** True when the operator has chosen a sound for outgoing calls. */
export function hasCustomRingback(): boolean {
  return sound.hasCustom();
}
